/**
   *  @ngdoc service
   *  @name adjust.service:Api
   *  @description
   *  All api resources are defined within this service
   */
function Api($resource, $http, configuration) {
  'ngInject';
  // Loads local files directly from ./.tmp/serve
  var local = $resource('/:file', { file: '@file' }, {
    get: { method: 'GET', withCredentials: false, withoutXhrHeader: true, ignore404: true },
    query: { method: 'GET', withCredentials: false, withoutXhrHeader: true, ignore404: true, isArray: true }
  });

  var signup = $resource(configuration.accounts.baseUrl + '/sign_up', {}, {
    get: {method: 'GET', critical: true}
  });

  var paymentMethod = $resource(configuration.accounts.baseUrl + '/accounts/0/payment_methods/:action', {
    action: '@action'
  }, {
    query: {method: 'GET', isArray: true, ignore404: true}
  });

  var productUpdate = $resource(configuration.productUpdates.baseUrl + '/:action', {
    action: '@action'
  }, {
    query: { method: 'GET', isArray: true, cacheStrategy: 'cacheFirst', cacheName: 'productUpdates', maxAge: '5 minutes'},
    save: { method: 'POST', cacheStrategy: 'clearCache', cacheName: 'productUpdates'},
  });

  var terms = $resource(configuration.terms.baseUrl + '/:lang/:action', {
    lang: '@lang',
    action: '@action'
  }, {
    get: { method: 'GET', ignore404: true }
  });

  var termsConfirm = $resource(configuration.accounts.baseUrl + '/term_confirmation/:action', {
    action: '@action'
  }, {
    get: { method: 'GET', ignore404: true },
    create: { method: 'POST' }
  });

  var unauthenticatedProductUpdate = $resource(configuration.unauthenticatedProductUpdates.baseUrl);

  var partnerDocs = $resource(configuration.spacedock.baseUrl + '/partners.json', {}, {
    get: {method: 'GET', withCredentials: false, withoutXhrHeader: true, ignore404: true}
  });

  var invoice = $resource(configuration.paymaster.baseUrl + '/invoices');

  var currentCharge = $resource(configuration.paymaster.baseUrl + '/current_charge', {}, {
    get: {method: 'GET', ignore404: true}
  });

  var appsList = $resource(configuration.dashboard.baseUrl + '/api/apps/:multiview', {}, {
    get: {method: 'GET', critical: true}
  });

  var app = $resource(configuration.dashboard.baseUrl + '/api/apps/:token', {}, {
    get: {method: 'GET', critical: true},
    create: {method: 'POST'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'}
  });

  var dashboard = $resource(configuration.dashboard.baseUrl + '/api/apps/:token/:action/:id/:subAction', {
    action: '@action',
    token: '@token',
    id: '@id',
    subAction: '@subAction'
  }, {
    get: {method: 'GET', redirectOnPermissionError: true},
    create: {method: 'POST'},
    update: {method: 'PUT'},
    patch: {method: 'PATCH'}
  });

  var device = $resource(configuration.deviceService.baseUrl + '/:action', {
    action: '@action',
    format: 'json'
  }, {
    query: {method: 'GET', params: {action: 'inspect_device'}, ignore404: true},
    delete: {method: 'POST', params: {action: 'forget_device', app_token: '@app_token', adid: '@adid'}}
  });

  var secrets = $resource(configuration.dashboard.baseUrl + '/api/apps/:appToken/secrets/:id/:action', {
    appToken: '@appToken',
    id: '@id',
    action: '@action'
  }, {
    query: {method: 'GET'},
    create: {method: 'POST'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'}
  });

  var tracker = $resource(configuration.dashboard.baseUrl + '/api/trackers/:token/:action', {
    action: '@action',
    token: '@token'
  }, {
    tolerantGet: {method: 'GET', ignore404: true},
    update: {method: 'PATCH'}
  });

  var currentAccount = $resource(configuration.accounts.baseUrl + '/current_account', {}, {
    get: {method: 'GET', critical: true}
  });

  var currentUser = $resource(configuration.accounts.baseUrl + '/current_user', {}, {
    get: {method: 'GET', critical: true}
  });

  var accountDashboard = $resource(configuration.dashboard.baseUrl + '/api/accounts');

  var account = $resource(configuration.accounts.baseUrl + '/accounts/:id/:action/:planId', {
    id: '@id',
    action: '@action',
    planId: '@planId'
  }, {
    query: {method: 'GET', isArray: true},
    post: {method: 'POST'},
    update: {method: 'PUT'},
    patch: {method: 'PATCH'}
  });

  var accountSwitch = $resource(configuration.accounts.baseUrl + '/accounts/switch.json', {}, {
    query: {method: 'GET', isArray: true, ignore404: true}
  });

  var accountSwitchViaToken = $resource(configuration.accounts.baseUrl + '/accounts/switch/switch_via_token', {}, {
    query: {method: 'GET', isArray: true, ignore404: true}
  });

  var user = $resource(configuration.accounts.baseUrl + '/accounts/:account_id/users/:id/:action', {
    account_id: '@account_id',
    id: '@id',
    action: '@action'
  }, {
    query: {method: 'GET', isArray: true},
    create: {method: 'POST'},
    remove: {method: 'DELETE'},
    update: {method: 'PUT'},
    patch: {method: 'PATCH'}
  });

  var session = $resource(configuration.accounts.baseUrl + '/users/:action', {
    action: '@action'
  }, {
    create: {method: 'POST'},
    remove: {method: 'DELETE'},
    update: {method: 'PATCH'}
  });

  var kpi = $resource(configuration.kpi.baseUrl + '/:appToken/:action/:trackerToken/:subAction', {
    appToken: '@appToken',
    action: '@action',
    trackerToken: '@trackerToken',
    subAction: '@subAction'
  }, {
    get: {method: 'GET', ignore404: true, cacheStrategy: 'cacheFirst', maxAge: '10 minutes'}
  });

  var sdkSecret = $resource(configuration.kpi.baseUrl + '/:appToken/sdk_secrets', {
    appToken: '@appToken'
  }, {
    get: {method: 'GET', ignore404: true, cacheStrategy: 'cacheFirst', maxAge: '10 minutes'}
  });

  var kpiApps = $resource(configuration.kpi.baseUrl, {}, {
    get: {method: 'GET', ignore404: true, cacheStrategy: 'cacheFirst', maxAge: '10 minutes'}
  });

  var billableKpiApps = $resource(configuration.kpi.baseUrl + '/:app_tokens/billable_attributions', {}, {
    get: {method: 'GET', ignore404: true, cacheStrategy: 'cacheFirst', maxAge: '10 minutes'}
  });

  var currency = $resource(configuration.dashboard.baseUrl + '/api/reporting_currencies', {}, {
    get: {method: 'GET', critical: true, cacheStrategy: 'cacheFirst', maxAge: '1 day'}
  });

  var timezone = $resource(configuration.accounts.baseUrl + '/timezones', {}, {
    query: {method: 'GET', isArray: true, cacheStrategy: 'cacheFirst', maxAge: '1 day'}
  });

  var appMonsta = $resource(configuration.dashboard.baseUrl + '/api/store_data/search', {}, {
    get: {method: 'GET', withCredentials: true}
  });

  var apptrace = $resource(configuration.apptrace.baseUrl + '/:action/:id/:subAction/:type', {
    action: '@action',
    id: '@id',
    subAction: '@subAction',
    type: '@type'
  }, {
    get: {method: 'GET', withCredentials: false}
  });

  var setup = $resource(configuration.dashboard.baseUrl + '/api/setup/:action', {
    action: '@action'
  }, {
    create: {method: 'POST'}
  });

  var settings = $resource(configuration.dashboard.baseUrl + '/api/apps/:appToken/settings/:settings', {
    appToken: '@appToken',
    settings: '@settings'
  }, {
    update: {method: 'POST'},
    remove: {method: 'DELETE'}
  });

  var partnerSettings = $resource(configuration.dashboard.baseUrl + '/api/apps/:appToken/settings/:settings/:partnerId/:subAction', {
    appToken: '@appToken',
    settings: '@settings',
    partnerId: '@partnerId',
    subAction: '@subAction'
  }, {
    query: {method: 'GET', isArray: true},
    post: {method: 'POST'},
    update: {method: 'PUT'},
    patch: {method: 'PATCH'},
    remove: {method: 'DELETE'}
  });

  var attributionSettings = $resource(configuration.dashboard.baseUrl + '/api/apps/:appToken/new_attribution_settings/:trackerToken', {
    appToken: '@appToken',
    trackerToken: '@trackerToken'
  }, {
    get: {method: 'GET'},
    update: {method: 'PUT'}
  });

  var imeiAttributionSettings = $resource(configuration.dashboard.baseUrl + '/api/apps/:appToken/imei', {
    appToken: '@appToken'
  }, {
    update: {method: 'PUT'}
  });

  var conversionSettings = $resource(configuration.dashboard.baseUrl + '/api/apps/:appToken/settings/partners/:id/platforms/:platform/conversion_ids/:conversionId', {
    appToken: '@appToken',
    platform: '@platform',
    id: '@id',
    conversionId: '@conversionId'
  }, {
    create: {method: 'POST'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'}
  });

  var parameterMappingSettings = $resource(configuration.dashboard.baseUrl + '/api/apps/:appToken/settings/partners/:id/platforms/:platform/parameter_mappings', {
    appToken: '@appToken',
    platform: '@platform',
    id: '@id'
  }, {
    create: {method: 'POST'},
    remove: {method: 'DELETE'}
  });

  var fraudPreventionSettings = $resource(configuration.dashboard.baseUrl + '/api/apps/:appToken/fraud_prevention_settings', {
    appToken: '@appToken'
  }, {
    get: {method: 'GET'},
    update: {method: 'PUT'}
  });

  var deployments = $resource(configuration.deployments.baseUrl + '/deployments', {}, {
    query: {method: 'GET', isArray: true, ignore404: true }
  });

   var revision = {
    get: params =>
      $http
        .get('/revision.txt', {
          params: params
        })
        .then(({data}) => data.replace(/\r?\n|\r/, ''))
  };

  var presets = $resource(configuration.userSettingsService.baseUrl + '/:appToken/presets/:slug', {
    appToken: '@appToken',
    slug: '@slug'
  }, {
    query: {method: 'GET', isArray: true},
    get: {method: 'GET'},
    post: {method: 'POST'},
    update: {method: 'PATCH'},
    remove: {method: 'DELETE'}
  });

  var apiToken = $resource(configuration.accounts.baseUrl + '/user/api_token', {}, {
    update: { method: 'PATCH' }
  });

  var audit = $resource(configuration.audit.baseUrl + '/events');

  var twitterSettings = $resource(configuration.dashboard.baseUrl + '/api/settings/:scope/:action/:id/:subAction', {
    scope: '@scope',
    action: '@action',
    id: '@id',
    subAction: '@subAction'
  }, {
    get: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    post: {method: 'POST'},
    batch: {method: 'POST', isArray: true}
  });

  const partner = $resource(configuration.dashboard.baseUrl + '/api/settings/:partnerId/:action/:id/:subAction', {
    action: '@action',
    subAction: '@subAction',
    id: '@id',
    partnerId: '@partnerId'
  }, {
    query: {method: 'GET', isArray: false},
  });

  const appleSearchAds = $resource(`${configuration.adAccounts.baseUrl}/api/settings/apple_search/:action/:id/:subAction`, {
    id: '@id',
    action: '@action',
    subAction: '@subAction'
  }, {
    get: {method: 'GET', ignore404: true},
    remove: {method: 'DELETE'},
    batch: {method: 'POST', isArray: true},
    post: {method: 'POST'}
  });

  const applovin = $resource(`${configuration.adAccounts.baseUrl}/api/settings/applovin/:action/:id/:subAction`, {
    id: '@id',
    action: '@action',
    subAction: '@subAction'
  }, {
    get: {method: 'GET', ignore404: true},
    remove: {method: 'DELETE'},
    post: {method: 'POST'},
    patch: {method: 'PATCH'},
  });

  const tiktok = $resource(`${configuration.adAccounts.baseUrl}/api/settings/tiktok/:action/:id/:subAction`, {
    id: '@id',
    action: '@action',
    subAction: '@subAction'
  }, {
    get: {method: 'GET', ignore404: true},
    post: {method: 'POST'},
    save: {method: 'POST'},
    remove: {method: 'DELETE'},
  });

  var segmentation = $resource(configuration.segmentation.baseUrl + '/:action/:id/:subAction', {
    action: '@action',
    id: '@id',
    subAction: '@subAction'
  }, {
    post: {method: 'POST'},
    create: {method: 'POST'},
    update: {method: 'PUT'},
    patch: {method: 'PATCH'},
    remove: {method: 'DELETE'}
  });

  function segmentEstimation(promise) {
    return $resource(configuration.segmentation.baseUrl + '/appschaetzli/:action/:id', {
      action: '@action',
      id: '@id'
    }, {
      post: {
        method: 'POST',
        timeout: promise
      }
    });
  }

  var segmentationExport = $resource(configuration.segmentation.baseUrl + '/exports/:id/to/:partner', {
    id: '@id',
    partner: '@partner'
  }, {
    create: {method: 'POST'},
    update: {method: 'PUT'},
    patch: {method: 'PATCH'},
    remove: {method: 'DELETE'}
  });


  return {
    local: local,
    account: account,
    accountSwitch: accountSwitch,
    accountSwitchViaToken: accountSwitchViaToken,
    accountDashboard: accountDashboard,
    appsList: appsList,
    app: app,
    dashboard: dashboard,
    appMonsta: appMonsta,
    apptrace: apptrace,
    attributionSettings: attributionSettings,
    imeiAttributionSettings: imeiAttributionSettings,
    currency: currency,
    timezone: timezone,
    currentAccount: currentAccount,
    currentUser: currentUser,
    deployments: deployments,
    fraudPreventionSettings: fraudPreventionSettings,
    conversionSettings: conversionSettings,
    parameterMappingSettings: parameterMappingSettings,
    kpi: kpi,
    kpiApps: kpiApps,
    billableKpiApps: billableKpiApps,
    settings: settings,
    partnerSettings: partnerSettings,
    revision: revision,
    setup: setup,
    tracker: tracker,
    user: user,
    session: session,
    presets: presets,
    partnerDocs: partnerDocs,
    signup: signup,
    paymentMethod: paymentMethod,
    apiToken: apiToken,
    audit: audit,
    invoice: invoice,
    currentCharge: currentCharge,
    productUpdate: productUpdate,
    twitterSettings: twitterSettings,
    partner: partner,
    unauthenticatedProductUpdate: unauthenticatedProductUpdate,
    device: device,
    segmentation: segmentation,
    segmentEstimation: segmentEstimation,
    segmentationExport: segmentationExport,
    secrets: secrets,
    terms: terms,
    termsConfirm: termsConfirm,
    sdkSecret: sdkSecret,
    appleSearchAds: appleSearchAds,
    applovin: applovin,
    tiktok: tiktok
  };
}

export { Api };
